import { app } from '../../../../app';
import { Controller } from './company-profile.controller';

app.component('companyProfile', {
    bindings:{
        settings:'<',
        accessPolicies:'<',
    },
    controller: Controller,
    templateUrl: require('./company-profile.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/company-profile.component.js